import { useContext, useEffect, useMemo, useState } from "react";
import { GeoContext } from "../context/GeoProvider";
import { withALErrorBoundary } from "../helpers/ErrorBoundary/ALErrorBoundary";
import { isCrawlerBot } from "@helpers/browser";
import ALPopup from "@components/al_components/ALPopup";
import { locales } from "../../locales";
import ArrowIcon from "./icons/svgs/arrow.svg";

function CountryConfirmationPopup() {
  const { countryDiffersPopupProps, closeCountryDiffersPopup, updateCountry } =
    useContext(GeoContext);
  const [selectedCountry, setSelectedCountry] = useState("US");

  useEffect(() => {
    if (countryDiffersPopupProps) {
      setSelectedCountry(countryDiffersPopupProps.CountryCode);
    }
  }, [countryDiffersPopupProps]);

  // Don't show the country confirmation popup for bots
  if (isCrawlerBot()) {
    return null;
  }

  const sortedLocales = useMemo(() => {
    const localesCopy = [...locales];
    localesCopy.sort((a, b) =>
      a.countryName.localeCompare(b.countryName, "en", { sensitivity: "base" })
    );
    return localesCopy;
  }, []);

  const handleSubmit = () => {
    updateCountry(selectedCountry);
  };

  return (
    <ALPopup
      isOpen={!!countryDiffersPopupProps}
      onClose={closeCountryDiffersPopup}
      title="Shipping somewhere else?"
      ctaTitle="Save & Continue"
      ctaOnClick={handleSubmit}
    >
      <p className="typo-body mb-[25px]">
        It looks like you&#39;re in a different country! We got you covered. Just select your
        location below and we&#39;ll take care of the rest.
      </p>

      <label htmlFor="countries" className="flex flex-col w-full">
        <span className="typo-body-bold">Deliver to</span>

        <div className="relative mt-[10px]">
          <ArrowIcon
            width="7"
            height="15"
            className="absolute right-[20px] top-1/2 -translate-y-1/2 pointer-events-none -rotate-90"
          />
          <select
            className="w-full border border-black rounded-[4px] px-[15px] py-[10px] typo-body appearance-none"
            id="countries"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
          >
            {sortedLocales.map((locale) => (
              <option key={locale.country} value={locale.country}>
                {locale.countryName}
              </option>
            ))}
          </select>
        </div>
      </label>
    </ALPopup>
  );
}

export default withALErrorBoundary({ name: "CountryDiffersPopup", priority: "P2" })(
  CountryConfirmationPopup
);
